module.exports = __webpack_public_path__ + "static/img/sb04.ce7e23f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/intellectualProperty/sb04.png
// module id = tjOS
// module chunks = 1